// Action Constants

export enum ActionConstant {
	GET_LIST = 'FILE://AI_PROMPTS/GET_SCOPE_DOCUMENT_PROMPT_LIST',
	GET_DETAILS = 'FILE://AI_PROMPTS/GET_SCOPE_DOCUMENT_PROMPT_DETAILS',
	GET_STATUS = 'FILE://AI_PROMPTS/GET__SCOPE_DOCUMENT_PROMPT_STATUS',
	CLEAR_DETAILS = 'FILE://AI_PROMPTS/CLEAR_SCOPE_DOCUMENT_PROMPT_DETAILS',
	CLEAR_STATUS = 'FILE://AI_PROMPTS/CLEAR_SCOPE_DOCUMENT_PROMPT_STATUS',
	CLEAR_LIST = 'FILE://AI_PROMPTS/CLEAR_SCOPE_DOCUMENT_PROMPT_LIST',
}

// State Types

export interface List {
	count: number;
	rows: [];
}
export interface Details {
	id: number;
	tradeId: number;
	divisionNumber: string;
	keywordHeading: string;
	grouping: string;
	promptText: string;
	promptType: string;
}

export interface InitialState {
	initialList: boolean;
	fetching: boolean;
	detailsFetching: boolean;
	specSummaryPromptList: Details[];
	scopePromptList: Details[];
	total: number;
	details: Details;
	keywords: string;
	statusCode: number;
	noOfResults: number;
	totalResults: number;
}

// Action Types

export interface GetListType {
	type: ActionConstant.GET_LIST;
	data: List;
}

export interface GetDetailsType {
	type: ActionConstant.GET_DETAILS;
	data: Details;
}

export interface GetStatusType {
	type: ActionConstant.GET_STATUS;
	status: number;
}

export interface ClearDetailsType {
	type: ActionConstant.CLEAR_DETAILS;
}

export interface ClearStatusType {
	type: ActionConstant.CLEAR_STATUS;
}

export interface ClearListType {
	type: ActionConstant.CLEAR_LIST;
}

export type ActionType =
	| GetListType
	| GetDetailsType
	| GetStatusType
	| ClearDetailsType
	| ClearStatusType
	| ClearListType;
